import React from 'react';
import PropTypes from 'prop-types';

import proNotifications from '../../../modules/proNotifications';
import StateLink from '../../StateLink';

import './Notification.scss';
import './VerificationDetailsNotification.scss';

/**
 * Add Verification Details notification
 */
export default function VerificationDetailsNotification(props) {
  const { notification } = props;
  const copy = 'Update information to process payments and enable a cancellation policy.';

  return (
    <section className="verification-details-notification notification">
      <div className="icon" />
      <section className="notification-body">
        <p className="notification-text">
          {copy}
        </p>
        <section className="buttons">
          <StateLink
            className="link"
            to="provider.settings_menu.payments"
            params={{ openVerificationDetails: true }}
            clickTracking={{
              name: proNotifications.NOTIFICATION_CLICKED_EVENT,
              params: proNotifications.createNotificationParams(notification),
            }}
          >
            Update
          </StateLink>
        </section>
      </section>
    </section>
  );
}

VerificationDetailsNotification.propTypes = {
  /** The notification object */
  notification: PropTypes.object.isRequired,
};
